import { SatPopoverModule } from '@ncstate/sat-popover';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';

import { SnBadgeModule } from '@lib/ui/badge';
import { SnIconModule } from '@lib/ui/icon';
import { SnMenuModule } from '@lib/ui/menu';
import { SnTooltipModule } from '@lib/ui/tooltip';

import { SnButtonComponent } from './components/button/button.component';
import { SnFabButtonComponent } from './components/fab-button/fab-button.component';
import { SnIconButtonComponent } from './components/icon-button/icon-button.component';
import { SnSmartButtonGroupComponent } from './components/smart-button-group/smart-button-group.component';
import { SortButtonComponent } from './components/sort-button/sort-button.component';
import { SpeedDialButtonComponent } from './components/speed-dial-button/speed-dial-button.component';
import { SnTextIconButtonComponent } from './components/text-icon-button/text-icon-button.component';
import { SnButtonGroupDirective } from './directives/button-group.directive';
import { SnButtonLabelDirective } from './directives/button-label.directive';

@NgModule({
  imports: [
    // Angular
    CommonModule,
    RouterModule,
    // Material
    MatProgressSpinnerModule,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    // Libs
    SnMenuModule,
    SnIconModule,
    SnBadgeModule,
    SnTooltipModule,
    SatPopoverModule,
  ],
  exports: [
    // Components
    SnButtonComponent,
    SnFabButtonComponent,
    SnIconButtonComponent,
    SortButtonComponent,
    SnTextIconButtonComponent,
    SnSmartButtonGroupComponent,
    SpeedDialButtonComponent,
    MatIconModule,
    // Directives
    SnButtonGroupDirective,
    SnButtonLabelDirective,
  ],
  declarations: [
    // Components
    SortButtonComponent,
    SnButtonComponent,
    SnFabButtonComponent,
    SnIconButtonComponent,
    SnTextIconButtonComponent,
    SnSmartButtonGroupComponent,
    // Directives
    SnButtonGroupDirective,
    SnButtonLabelDirective,
    SpeedDialButtonComponent,
  ],
})
export class SnButtonModule {}
